
import useAllUserOrders from "../../hooks/useAllUserOrders";
import Error from "../Error/Error";
import Loading from "../Loading/Loading";

export default function AllOrders() {
    const userId = localStorage.getItem('userId') ?? null
    const { isLoading, isError, data } = useAllUserOrders(userId)
    return <>

        {isLoading && <Loading />}
        {data &&
            <section>
                {data?.map(order => <div className="row my-3 bg-light rounded-3 p-4">
                    <div className="col-md-6">
                        <p className=" fw-bolder fs-4 ">Order ID : {order._id}</p>
                    </div>
                    <div className="col-md-6 text-end">
                        <span className="me-3">{order.isPaid ? `Date: ${order.paidAt.split('T')[0]}` : null}</span>
                        <span className={`${order.isPaid ? "bg-main" : "bg-danger"} px-3 py-2 text-white rounded-3`} >{order.isPaid ? "Paid" : "Not Paid"}</span>
                    </div>
                    {order.cartItems.map((item) =>
                        <div className="row">
                            <div className="col-md-1 my-2 rounded-3">
                                <img className="w-100" src={item.product.imageCover} alt={item.product.title} />
                            </div>
                            <div className="col-md-8">
                                <div className="item-info d-flex flex-column py-4  ">
                                    <span className="my-1 text-main fs-5">{item.product.title.split(' ').slice(0, 3).join(' ')}</span>
                                    <span className="fw-bolder">Quantity: {item.count}</span>
                                    <span className="fw-bolder text-main">Price: {item.price} EGP</span>
                                </div>
                            </div>
                            <div className="col-md-3 text-end pt-4">
                                <span className="text-black">Total:{item.count * item.price} <span className="text-main">EGP</span></span>
                            </div>
                        </div>

                    )}
                    <div className="col-md-12 text-end pb-3">
                        <span className="fw-bolder fs-5" >Order Total: <span className="bg-main text-white py-1 px-2 rounded-4">{order.totalOrderPrice}</span> EGP</span>
                    </div>
                </div>
                )}
            </section>
        }
        {isError && <Error />}
    </>
}